module.exports = __webpack_public_path__ + "img/the-cottages-sign.5d476cbf.jpg";